import { DomainItem } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import { httpUrl } from '@/renderer/scripts/http';
import store from '@/renderer/store';

// 根据域名列表获取自定义域名或者url的域名
export function getCustomDomainOrWebUrl(domains: DomainItem[]) {
  let customDomain = httpUrl.webUrl;
  // 会议渠道不支持自定义域名
  if (domains && domains.length !== 0 && !store.getters.isInWeMeetApp) {
    const domainItem = domains.filter(item => item.isCustom);
    if (domainItem && domainItem.length && domainItem[0].domain) {
      customDomain = `${httpUrl.protocol}://${domainItem[0].domain}`;
    }
  }
  return customDomain;
}
